<template lang="html">
  <modal name="cost-tooltip-modal" height="auto" width="416" :adaptive="true" :maxWidth="409" class="cost-tooltip-modal">
    <div class="modal-container">
      <div class="modal-header bold">
        Pricing
      </div>
      <div class="line-break-gray" />
      <div class="modal-body">
        A coupon has been applied to lower your first year price.  After the first year, the cost of your service will be renewed at the standard price.
      </div>
      <div class="line-break-gray" />
      <div class="modal-footer">
        <SymbiumButton
          text="Close"
          :onClick="close"
          :isSmall="true"
        />
      </div>
    </div>
  </modal>
</template>

<script>
import SymbiumButton from 'src/components/common/SymbiumButton.vue'

export default {
  components: { SymbiumButton },
  methods: {
    close() {
      this.$modal.hide('cost-tooltip-modal');
    }
  }
}
</script>

<style lang="scss">
.cost-tooltip-modal {
  .title {
    font-weight: 600;
    font-size: 24px;
    line-height: 32px;
    letter-spacing: -0.18px;
  }

  .modal-footer .oval-button {
    padding: 8px 16px;
    margin: 0;

    .text {
      line-height: 14px;
    }
  }
}
</style>
